import React from 'react';
export const IdentificationCheck = () => (
  <svg width="201px" height="158px" viewBox="0 0 201 158" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1028.000000, -990.000000)">
        <g transform="translate(1028.000000, 990.000000)">
          <path
            d="M148.569827,153.828286 L52.4303682,153.828286 L0.508570047,101.847549 C-0.169523349,101.168692 -0.169523349,100.057914 0.508570047,99.3790569 L99.2670336,0.508488428 C99.9459986,-0.169496143 101.054655,-0.169496143 101.732749,0.508488428 L200.492084,99.3790569 C201.169305,100.057914 201.169305,101.168692 200.492084,101.847549 L148.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <path
            d="M176.2466,152.9965 L144.5016,152.9965"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M57.4156,152.9965 L38.6596,152.9965"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M28.6592,152.9965 L20.6232,152.9965"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M120.0611,153.1069 C120.0611,155.4169 112.3931,157.2889 102.9351,157.2889 C93.4761,157.2889 85.8091,155.4169 85.8091,153.1069 C85.8091,150.7969 93.4761,148.9249 102.9351,148.9249 C112.3931,148.9249 120.0611,150.7969 120.0611,153.1069"
            fill="#D0D7DA"
          />
          <path
            d="M80.7027,48.8012 L80.7027,50.5512"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M80.7027,54.0512 L80.7027,55.8012"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M84.2027,52.3012 L82.4527,52.3012"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M78.9527,52.3012 L77.2027,52.3012"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M142.3214,125.2074 L142.3214,127.2074"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M142.3214,131.2074 L142.3214,133.2074"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M146.3214,129.2074 L144.3214,129.2074"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M140.3214,129.2074 L138.3214,129.2074"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M153.1983,121.4125 C153.1983,122.2505 152.5183,122.9305 151.6803,122.9305 C150.8423,122.9305 150.1623,122.2505 150.1623,121.4125 C150.1623,120.5745 150.8423,119.8945 151.6803,119.8945 C152.5183,119.8945 153.1983,120.5745 153.1983,121.4125"
            fill="#CCD82B"
          />
          <path
            d="M59.0748,65.8442 C59.0748,66.6832 58.3948,67.3632 57.5568,67.3632 C56.7188,67.3632 56.0388,66.6832 56.0388,65.8442 C56.0388,65.0062 56.7188,64.3262 57.5568,64.3262 C58.3948,64.3262 59.0748,65.0062 59.0748,65.8442"
            fill="#F5C400"
          />
          <g transform="translate(68.000000, 79.710000)">
            <path
              d="M2.9346,7.933 L3.4426,2.784 C3.5886,1.304 4.9066,0.223 6.3856,0.37 L62.8936,5.946 C64.3726,6.091 65.4546,7.41 65.3086,8.888 L62.1336,41.054 C61.9876,42.534 60.6696,43.615 59.1906,43.468 L2.6826,37.892 C1.2036,37.745 0.1226,36.428 0.2686,34.949 L2.3926,13.416"
              fill="#FFFFFF"
            />
            <path
              d="M2.9346,7.933 L3.4426,2.784 C3.5886,1.304 4.9066,0.223 6.3856,0.37 L62.8936,5.946 C64.3726,6.091 65.4546,7.41 65.3086,8.888 L62.1336,41.054 C61.9876,42.534 60.6696,43.615 59.1906,43.468 L2.6826,37.892 C1.2036,37.745 0.1226,36.428 0.2686,34.949 L2.3926,13.416"
              stroke="#DDE5E8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(65.000000, 70.710000)">
            <path
              d="M1.1934,13.0912 L0.7704,7.9332 C0.6494,6.4512 1.7524,5.1522 3.2334,5.0302 L59.8264,0.3942 C61.3084,0.2722 62.6074,1.3752 62.7294,2.8572 L65.3684,35.0702 C65.4894,36.5522 64.3874,37.8512 62.9054,37.9732 L6.3124,42.6102 C4.8314,42.7312 3.5314,41.6282 3.4104,40.1472 L1.6434,18.5822"
              fill="#FFFFFF"
            />
            <path
              d="M1.1934,13.0912 L0.7704,7.9332 C0.6494,6.4512 1.7524,5.1522 3.2334,5.0302 L59.8264,0.3942 C61.3084,0.2722 62.6074,1.3752 62.7294,2.8572 L65.3684,35.0702 C65.4894,36.5522 64.3874,37.8512 62.9054,37.9732 L6.3124,42.6102 C4.8314,42.7312 3.5314,41.6282 3.4104,40.1472 L1.6434,18.5822"
              stroke="#7350A0"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M89.7701,95.975 C90.4911,94.637 90.8471,93.074 90.7121,91.435 C90.3491,86.997 86.5291,83.69 82.1801,84.046 C77.8321,84.403 74.6011,88.288 74.9651,92.726 C75.0991,94.365 75.7051,95.849 76.6341,97.051"
            stroke="#D62793"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M85.5401,88.3871 C85.5401,88.3871 86.2791,89.4231 86.2121,91.9321 C86.2121,91.9321 86.2901,94.1791 84.7631,95.5771 L88.8571,97.0101 L88.7181,97.1711 C87.4171,98.6371 85.5741,99.6211 83.4701,99.7941 C81.3671,99.9661 79.3881,99.2951 77.8661,98.0611 L77.7031,97.9251 L78.5611,97.4551 L81.5081,95.8441 C79.7741,94.7121 79.5121,92.4811 79.5121,92.4811 C79.0371,90.0161 79.5711,88.8761 79.5711,88.8761 C79.5711,88.8761 80.2511,87.1771 82.4221,86.9991 C84.5921,86.8221 85.5401,88.3871 85.5401,88.3871 Z"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M122.6988,88.8168 L98.5468,90.7868 C97.9458,90.8358 97.4138,90.3838 97.3658,89.7838 C97.3168,89.1828 97.7678,88.6508 98.3678,88.6018 L122.5208,86.6318 C123.1208,86.5838 123.6528,87.0348 123.7018,87.6348 C123.7508,88.2358 123.2998,88.7678 122.6988,88.8168"
            fill="#DDE5E8"
          />
          <path
            d="M122.1275,83.2172 L97.9755,85.1872 C97.3755,85.2362 96.8435,84.7842 96.7945,84.1842 C96.7455,83.5832 97.1965,83.0512 97.7975,83.0022 L121.9495,81.0322 C122.5505,80.9842 123.0815,81.4352 123.1305,82.0352 C123.1795,82.6362 122.7285,83.1672 122.1275,83.2172"
            fill="#DDE5E8"
          />
          <path
            d="M98.8082,101.2289 C99.9512,101.0199 100.8622,100.1859 101.7052,99.3879 C103.1512,98.0199 104.5972,96.6519 106.0422,95.2849 C105.5052,96.8549 104.9672,98.4249 104.4292,99.9959 C105.2872,100.1099 106.0712,99.5259 106.7042,98.9349 C107.3372,98.3439 107.9982,97.6779 108.8572,97.5649 C109.7152,97.4529 110.7042,98.2979 110.3502,99.0879 C110.8102,100.0529 110.3732,101.3459 109.4232,101.8349 C109.3792,100.5669 110.1382,99.3669 111.1612,98.6149 C112.1832,97.8629 113.4402,97.4989 114.6892,97.2729 C115.4592,97.1329 116.3182,97.0589 116.9662,97.4989 C117.6132,97.9389 117.7642,99.0919 117.0632,99.4409 C118.7422,98.2409 120.8632,97.6749 122.9172,97.8809"
            stroke="#D62793"
            strokeWidth="0.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M103.3443,108.3461 L126.0503,106.4861 C126.9233,106.4141 127.5723,105.6491 127.5003,104.7771 L127.0883,99.7471"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.1656,117.8442 L125.8156,119.0222"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M103.149,116.7309 L109.957,117.4179"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M96.3585,108.9184 L100.1335,108.6084"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(117.000000, 60.710000)">
            <path
              d="M5.3072,1.6312 C6.6222,0.9092 8.1332,0.4992 9.7402,0.4992 C14.8402,0.4992 18.9742,4.6342 18.9742,9.7352 C18.9742,14.8352 14.8402,18.9702 9.7402,18.9702 C4.6392,18.9702 0.5042,14.8352 0.5042,9.7352 C0.5042,8.4592 0.7632,7.2452 1.2302,6.1402"
              fill="#FFFFFF"
            />
            <path
              d="M5.3072,1.6312 C6.6222,0.9092 8.1332,0.4992 9.7402,0.4992 C14.8402,0.4992 18.9742,4.6342 18.9742,9.7352 C18.9742,14.8352 14.8402,18.9702 9.7402,18.9702 C4.6392,18.9702 0.5042,14.8352 0.5042,9.7352 C0.5042,8.4592 0.7632,7.2452 1.2302,6.1402"
              stroke="#CCD82B"
              strokeLinecap="round"
            />
          </g>
          <polyline
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="131.1812 68.1908 128.5302 70.8428 125.9502 73.5168 123.2642 71.0188 123.1012 70.8678"
          />
          <path
            d="M141.3214,70.4447 L151.8864,70.4447 L151.8864,95.2847 L135.9744,95.2847"
            stroke="#AA81F7"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="3,6"
          />
        </g>
      </g>
    </g>
  </svg>
);
